import { createSlice } from '@reduxjs/toolkit';

export const startupSlice = createSlice({
    name: 'startup',
    initialState: {
        dataToAction: { name: '', alias: '', country: '', cif: '', registrationDate: '', constitutionDate: '', sector: '' , url: '' }
    },
    reducers: {
        selectStartup: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectStartup: (state) => {
            state.dataToAction = {
                userToAction: { name: '', alias: '', country: '', cif: '', registrationDate: '', constitutionDate: '', sector: '' , url: '' }
            }
        }
    }
});

export const { selectStartup, unSelectStartup } = startupSlice.actions;